import React, { useState, useEffect } from 'react';
import { FaEdit } from "react-icons/fa";
import { LuPlayCircle } from "react-icons/lu";
import { BiArchiveIn } from "react-icons/bi"
import { courseListRes, courseListTodo } from '../../LMS_Redux/LMS_Slices/Course/CourseList';
import { useDispatch, useSelector } from 'react-redux';
import PropagateLoader from "react-spinners/PropagateLoader";
import { FiRefreshCw } from "react-icons/fi"
import { Tooltip } from 'react-tooltip';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Tab, Tabs } from 'react-bootstrap';
import { TiInfoOutline } from "react-icons/ti";
import { publicCourseRes, publicCourseTodo } from '../../LMS_Redux/LMS_Slices/Course/PublicCourse';

export default function CourseList() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state.courseList && state.courseList.data && state.courseList.data.data)
    const [loading, setLoading] = useState(false)
    const [bool, setBool] = useState(false)
    // console.log(data)

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'IMAGE',
            field: 'thumbnail_image',
            cellRenderer: (params) => <img src={process.env.REACT_APP_IMAGE_URL + `${params.value}`} alt="img" className='img-fluid' width="50" height="50" />,
            suppressMenu: true,
            filter: false,
            sortable: false,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'TITLE',
            field: 'course_title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'ID',
            field: 'course_code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'TYPE',
            field: 'course_type',
            cellRenderer: params => <span className='text-capitalize'>{params.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        // {
        //     headerName: 'DEPARTMENT',
        //     field: 'department_data',
        //     valueFormatter: function (params) {
        //         return params.data && params.data.department_data && params.data.department_data.map(val => `${val.label}`).join(',')
        //     },
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     filter: true,
        //     sortable: true,
        //     floatingFilter: true,
        //     // wrapText: true,
        //     // autoHeight: true,
        // },
        {
            headerName: 'REVISION',
            field: 'revise',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params => params.value == 'active' ? <span className='badge text-bg-success'>Active</span> : <span className='badge text-bg-danger'>Inactive</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
        {
            headerName: 'CREATED ON',
            field: 'course_created',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
            minWidth: 155,
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <LuPlayCircle size={20} className='eye'
                        onClick={() => course_details(params)}
                        data-tooltip-id='details'
                        data-tooltip-content="Details!"
                        data-tooltip-place="bottom"
                    />

                    {role == 'Admin' && params.data.course_availability == 'public' ?
                        <>
                            <FiRefreshCw size={20} className='edit ms-3'
                                onClick={() => edit_course(params)}
                                data-tooltip-id='revise'
                                data-tooltip-content="Revise!"
                                data-tooltip-place="bottom"
                            />
                            <BiArchiveIn size={20} className='archive ms-3'
                                onClick={() => archive_course(params)}
                                data-tooltip-id='archive'
                                data-tooltip-content="Archive!"
                                data-tooltip-place="bottom"
                            />
                        </>
                        : ''
                    }

                    {role == 'Admin' && params.data.course_availability == 'private' ?
                        <TiInfoOutline size={20} className='edit ms-3'
                            onClick={() => public_course(params)}
                            data-tooltip-id='public'
                            data-tooltip-content="Public!"
                            data-tooltip-place="bottom"
                        />
                        : ''
                    }

                    {role == 'Admin' && params.data.course_availability == 'draft' ?
                        <FaEdit size={20} className='edit ms-3'
                            onClick={() => update_course(params)}
                            data-tooltip-id='edit'
                            data-tooltip-content="Update!"
                            data-tooltip-place="bottom"
                        />
                        : ''
                    }

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='revise' style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='archive' style={{ backgroundColor: "rgb(255,193,7)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='public' style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='edit' style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            autoHeight: true,
        }
    ]);

    const edit_course = (params) => {
        Swal.fire({
            title: 'Revise Learning Module',
            text: `Are you sure want to Revise Learning Module?`,
            input: "textarea",
            inputPlaceholder: "Enter reason for revision...",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#105684',
            cancelButtonColor: '#9d9d9d',
            confirmButtonText: 'Ok',
            inputValidator: (value) => {
                // Validate the input here
                if (!value) {
                    return 'You have to enter reason for revision!';
                }
            }
        }).then((result) => {
            if (result.isConfirmed) {
                var test = params.data
                var reason = { ...test, "reason": result.value }
                navigate('/add_course', { state: reason })
            }
        })
    }

    const course_details = (params) => {
        navigate('/course_details', { state: params.data })
    }

    const archive_course = (params) => {
        navigate('/archive_course', { state: params.data })
    }

    const public_course = (params) => {
        Swal.fire({
            title: 'Public Learning Module',
            text: `Are you sure want to Public this Learning Module?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#105684',
            cancelButtonColor: '#9d9d9d',
            confirmButtonText: 'Ok',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(publicCourseTodo({ "course_id": params.data.id, "course_code": params.data.course_code_original, "course_availability": 'public' })).then(() => public_res())
            }
        })
    }

    const public_res = () => {
        if (publicCourseRes && publicCourseRes.success) {
            Swal.fire(
                'Learning Module Status',
                publicCourseRes.message,
                'success'
            )
            setBool(!bool)
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: publicCourseRes.message,
            })
        }
    }

    const update_course = (params) => {
        var test = params.data
        var reason = { ...test, "draft": true }
        navigate('/add_course', { state: reason })
    }

    const course_res = () => {
        if (courseListRes && courseListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(courseListTodo({ "temp": 'list', "course_availability": key, "course_type": '' })).then(() => course_res())
    }, [bool])

    const [key, setKey] = useState('private')

    const tab_change = (key) => {
        setLoading(true)

        if (key == 'public') {
            dispatch(courseListTodo({ "temp": 'list', "course_availability": 'public', "course_type": '' })).then(() => course_res())
        } else if (key == 'private') {
            dispatch(courseListTodo({ "temp": 'list', "course_availability": 'private', "course_type": '' })).then(() => course_res())
        } else if (key == 'draft') {
            dispatch(courseListTodo({ "temp": 'list', "course_availability": 'draft', "course_type": '' })).then(() => course_res())
        }
    }

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Learning Module Management / </span>
                    <span className='icon2'>Learning Module List</span>
                </div>

                <Tabs
                    // defaultActiveKey="course"
                    activeKey={key}
                    onSelect={(k) => { setKey(k); tab_change(k) }}
                    id="justify-tab-example"
                    className="piils_btn mb-3"
                    justify
                >
                    <Tab eventKey="private" title="Private" disabled={loading}>
                        {loading ?
                            <div className='wrapper-admin'>
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <>
                                {data && data.length ?
                                    <DataTables
                                        rowData={data}
                                        columnDefs={columnDefs}
                                        height={'60vh'}
                                    />
                                    :
                                    <div className='wrapper-admin'>
                                        <div className='text-center'>
                                            <h5>Private Learning Module List Not Found</h5>
                                        </div>
                                    </div>
                                }
                            </>
                        }
                    </Tab>

                    <Tab eventKey="public" title="Public" disabled={loading}>
                        {loading ?
                            <div className='wrapper-admin'>
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <>
                                {data && data.length ?
                                    <DataTables
                                        rowData={data}
                                        columnDefs={columnDefs}
                                        height={'60vh'}
                                    />
                                    :
                                    <div className='wrapper-admin'>
                                        <div className='text-center'>
                                            <h5>Public Learning Module List Not Found</h5>
                                        </div>
                                    </div>
                                }
                            </>
                        }
                    </Tab>

                    <Tab eventKey="draft" title="Draft" disabled={loading}>
                        {loading ?
                            <div className='wrapper-admin'>
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <>
                                {data && data.length ?
                                    <DataTables
                                        rowData={data}
                                        columnDefs={columnDefs}
                                        height={'60vh'}
                                    />
                                    :
                                    <div className='wrapper-admin'>
                                        <div className='text-center'>
                                            <h5>Draft Learning Module List Not Found</h5>
                                        </div>
                                    </div>
                                }
                            </>
                        }
                    </Tab>

                </Tabs>

                {/* {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <>
                        {data && data.length ?
                            <DataTables
                                rowData={data}
                                columnDefs={columnDefs}
                            />
                            :
                            <div className='wrapper-admin'>
                                <div className='text-center'>
                                    <h5>Course List Not Found</h5>
                                </div>
                            </div>
                        }
                    </>
                } */}

            </div>
        </>
    );
}